// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { Link, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import styles from "./JobForm.module.css";
// import Gfooter from "../Component/Gfooter";

// gsap.registerPlugin(ScrollTrigger);

// const ADD_API =
//   "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/add_application";

// const initial = {
//   first_name: "", middle_name: "", last_name: "",
//   gender: "", email: "", country_code: "+91", mobile_phone: "",
//   experience_years: "", experience_months: "",
//   current_salary: "", current_salary_currency: "INR",
//   expected_salary: "", available_to_join_days: "",
//   current_location: "", current_company: "", linkedin_url: "",
//   job_role: "", resume_file: null,
//   companyName: "", jobTitle: "", currentlyWorking: false,
//   dateOfJoining: "", dateOfRelieving: "", experience_location: "",
// };

// /* ── Framer variants ── */
// const blockVar = {
//   hidden: { opacity: 0, y: 36 },
//   show:   { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] } },
// };

// const heroVar = {
//   hidden: { opacity: 0, y: -24 },
//   show:   { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
// };

// const expVar = {
//   hidden: { opacity: 0, height: 0, overflow: "hidden" },
//   show:   { opacity: 1, height: "auto", transition: { duration: 0.45, ease: "easeOut" } },
//   exit:   { opacity: 0, height: 0,    transition: { duration: 0.3 } },
// };

// /* ── Helper: Section Block ── */
// function SBlock({ icon, title, children, delay = 0 }) {
//   return (
//     <motion.div
//       className={styles.sectionBlock}
//       variants={blockVar}
//       initial="hidden"
//       whileInView="show"
//       viewport={{ once: true, margin: "-60px" }}
//       transition={{ delay }}
//     >
//       <div className={styles.sectionHead}>
//         <div className={styles.sectionHeadIcon}>{icon}</div>
//         <span className={styles.sectionHeadTitle}>{title}</span>
//       </div>
//       <div className={styles.sectionBody}>{children}</div>
//     </motion.div>
//   );
// }

// /* ── Helper: Field ── */
// function Field({ label, required, children }) {
//   return (
//     <div className={styles.field}>
//       <label className={styles.fieldLabel}>
//         {label}{required && <span>*</span>}
//       </label>
//       {children}
//     </div>
//   );
// }

//  function JobForm() {
//   const location = useLocation();
//   const [formData, setFormData]           = useState(initial);
//   const [resumeName, setResumeName]       = useState("");
//   const [error, setError]                 = useState(null);
//   const [successMsg, setSuccessMsg]       = useState("");
//   const [submitting, setSubmitting]       = useState(false);
//   const [showExp, setShowExp]             = useState(false);
//   const resumeInputRef                    = useRef(null);

//   const jobRoleFromPage = location.state?.jobRole || "";

// useEffect(() => {
//   if (jobRoleFromPage) {
//     setFormData(prev => ({
//       ...prev,
//       job_role: jobRoleFromPage
//     }));
//   }
// }, [jobRoleFromPage]);
  
//   /* GSAP entrance on hero */
//   const heroRef = useRef(null);
//   useEffect(() => {
//     if (heroRef.current) {
//       gsap.fromTo(
//         heroRef.current.querySelectorAll(".gsap-hero-el"),
//         { opacity: 0, y: 40 },
//         { opacity: 1, y: 0, stagger: 0.14, duration: 0.8, ease: "power3.out", delay: 0.1 }
//       );
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(p => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       setFormData(p => ({ ...p, resume_file: file }));
//       setResumeName(file.name);
//     }
//   };

//   const sendEmailNotification = () => {
//     const subject = `New Job Application - ${formData.job_role || "Position"}`;
//     const body = `
// NEW JOB APPLICATION RECEIVED

// NAME: ${formData.first_name} ${formData.middle_name} ${formData.last_name}
// GENDER: ${formData.gender}
// EMAIL: ${formData.email}
// PHONE: ${formData.country_code} ${formData.mobile_phone}

// JOB ROLE: ${formData.job_role || "Not specified"}
// CURRENT LOCATION: ${formData.current_location}

// EXPERIENCE: ${formData.experience_years || 0} Years ${formData.experience_months || 0} Months
// ${formData.companyName     ? `COMPANY: ${formData.companyName}`               : ""}
// ${formData.jobTitle        ? `POSITION: ${formData.jobTitle}`                 : ""}
// ${formData.experience_location ? `WORK LOCATION: ${formData.experience_location}` : ""}
// ${formData.dateOfJoining   ? `JOINING: ${formData.dateOfJoining}`             : ""}
// ${formData.currentlyWorking ? "CURRENTLY WORKING: Yes" : formData.dateOfRelieving ? `RELIEVING: ${formData.dateOfRelieving}` : ""}

// CURRENT SALARY: ${formData.current_salary} ${formData.current_salary_currency}
// EXPECTED SALARY: ${formData.expected_salary}
// AVAILABLE IN: ${formData.available_to_join_days} days

// LINKEDIN: ${formData.linkedin_url || "Not provided"}
// RESUME: ${resumeName || "Not uploaded"}

// Submitted: ${new Date().toLocaleString()}
//     `;
//     window.location.href = `mailto:info@nlfs.in?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null); setSuccessMsg("");
//     if (!formData.first_name || !formData.last_name || !formData.email) {
//       setError("Please fill all required fields."); return;
//     }
//     try {
//       setSubmitting(true);
//       const payload = new FormData();
//       Object.entries(formData).forEach(([key, val]) => {
//         if (val !== null && val !== "") {
//           const map = { companyName: "current_company", jobTitle: "job_title", currentlyWorking: "currently_working", dateOfJoining: "date_of_joining", dateOfRelieving: "date_of_relieving" };
//           if (key === "currentlyWorking") payload.append("currently_working", val ? 1 : 0);
//           else payload.append(map[key] || key, val);
//         }
//       });
//       const res = await axios.post(ADD_API, payload, { headers: { "Content-Type": "multipart/form-data" } });
//       if (res.data?.status) {
//         sendEmailNotification();
//         setSuccessMsg(res.data.message || "Application submitted successfully!");
//         setFormData(initial); setResumeName(""); setShowExp(false);
//       } else { setError(res.data?.message || "Submission failed"); }
//     } catch (err) {
//       setError(err.response?.data?.message || err.message || "Network error");
//     } finally { setSubmitting(false); }
//   };

//   /* SVG icons */
//   const iconPerson = <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>;
//   const iconBag    = <svg viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>;
//   const iconMoney  = <svg viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>;
//   const iconPin    = <svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
//   const iconExp    = <svg viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>;

//   return (
//     <>
//     <div className={styles.page}>

//       {/* ── TOP BAR ── */}
//       <div className={styles.topBar}>
//         <Link to="/careers" className={styles.backLink}>
//           <svg viewBox="0 0 24 24"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
//           Back to all job openings
//         </Link>
//       </div>

//       {/* ── HERO BANNER ── */}
//       <div className={styles.heroBanner} ref={heroRef}>
//         <div className={styles.heroContent}>
//           <div className={`${styles.heroEyebrow} gsap-hero-el`}>Careers at NLF</div>
//           {/* <h1 className={`${styles.heroTitle} gsap-hero-el`}>Apply for This Position</h1> */}
//          <h1 className={`${styles.heroTitle} gsap-hero-el`}>
//   Apply for This Position{" "}
//   {jobRoleFromPage && (
//     <span style={{ color: "#ff0000" }}>
//       - {jobRoleFromPage}
//     </span>
//   )}
// </h1>
//           <p className={`${styles.heroSub} gsap-hero-el`}>Fill in your details below — we'll get back to you shortly.</p>
//         </div>
//       </div>

//       {/* ── RESUME UPLOAD ── */}
//       <div className={styles.resumeZone}>
//         <motion.div
//           className={styles.resumeCard}
//           onClick={() => resumeInputRef.current?.click()}
//           initial={{ opacity: 0, y: 24 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.55, delay: 0.3 }}
//           whileHover={{ scale: 1.01 }}
//         >
//           <div className={styles.resumeIcon}>
//             <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
//           </div>
//           <div className={styles.resumeText}>
//             <strong>Upload Resume / CV</strong>
//             <small>PDF, DOC, DOCX — max 10 MB</small>
//             {resumeName && (
//               <div className={styles.resumeFileName}>
//                 <svg width="12" height="12" viewBox="0 0 24 24" stroke="#DB0606" fill="none" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
//                 {resumeName}
//               </div>
//             )}
//           </div>
//           <input ref={resumeInputRef} type="file" accept=".pdf,.doc,.docx" onChange={handleFileChange} style={{ display: "none" }} />
//         </motion.div>
//       </div>

//       {/* ── FORM ── */}
//       <div className={styles.formWrap}>
//         <form onSubmit={handleSubmit} noValidate>

//           {/* 1. Personal Info */}
//           <SBlock icon={iconPerson} title="Personal Information" delay={0}>
//             <div className={`${styles.row} ${styles.cols3}`}>
//               <Field label="First Name" required>
//                 <input className={styles.fieldInput} name="first_name" value={formData.first_name} onChange={handleChange} placeholder="John" required />
//               </Field>
//               <Field label="Middle Name">
//                 <input className={styles.fieldInput} name="middle_name" value={formData.middle_name} onChange={handleChange} placeholder="(optional)" />
//               </Field>
//               <Field label="Last Name" required>
//                 <input className={styles.fieldInput} name="last_name" value={formData.last_name} onChange={handleChange} placeholder="Doe" required />
//               </Field>
//             </div>
//             <div className={`${styles.row} ${styles.cols3}`}>
//               <Field label="Gender" required>
//                 <select className={styles.fieldSelect} name="gender" value={formData.gender} onChange={handleChange} required>
//                   <option value="">Select</option>
//                   <option>Male</option><option>Female</option><option>Other</option>
//                 </select>
//               </Field>
//               <Field label="Email Address" required>
//                 <input className={styles.fieldInput} type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" required />
//               </Field>
//               <Field label="Mobile Phone">
//                 <div className={styles.inputGroup}>
//                   <select className={styles.fieldSelect} name="country_code" value={formData.country_code} onChange={handleChange}>
//                     <option value="+91">+91</option>
//                     <option value="+1">+1</option>
//                     <option value="+44">+44</option>
//                   </select>
//                   <input className={styles.fieldInput} type="tel" name="mobile_phone" value={formData.mobile_phone} onChange={handleChange} placeholder="9876543210" required />
//                 </div>
//               </Field>
//             </div>
//           </SBlock>

//           {/* 2. Job Details */}
//           {/* <SBlock icon={iconBag} title="Job Details" delay={0.05}>
//             <div className={`${styles.row} ${styles.cols2}`}>
//               <Field label="Job Role">
//                 <select className={styles.fieldSelect} name="job_role" value={formData.job_role} onChange={handleChange}>
//                   <option value="">Select a role</option>
//                   <option value="Procurement">Procurement Executive</option>
//                   <option value="Interior">Interior Designer</option>
//                   <option value="Project">Project Manager – Turnkey Solutions</option>
//                 </select>
//               </Field>
//               <Field label="LinkedIn URL">
//                 <input className={styles.fieldInput} name="linkedin_url" value={formData.linkedin_url} onChange={handleChange} placeholder="https://linkedin.com/in/..." />
//               </Field>
//             </div>
//           </SBlock> */}

//           {/* 3. Experience */}
//           <SBlock icon={iconExp} title="Experience" delay={0.1}>
//             <div className={`${styles.row} ${styles.cols4}`}>
//               <Field label="Years">
//                 <input className={styles.fieldInput} type="number" name="experience_years" value={formData.experience_years} onChange={handleChange} placeholder="0" min="0" />
//               </Field>
//               <Field label="Months">
//                 <select className={styles.fieldSelect} name="experience_months" value={formData.experience_months} onChange={handleChange}>
//                   <option value="">Months</option>
//                   {Array.from({ length: 12 }, (_, i) => <option key={i} value={i}>{i}</option>)}
//                 </select>
//               </Field>
//             </div>

//             {/* Toggle Experience Details */}
//             <button
//               type="button"
//               className={`${styles.expToggleBtn} ${showExp ? styles.open : ""}`}
//               onClick={() => setShowExp(v => !v)}
//             >
//               <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
//               {showExp ? "Hide Experience Details" : "Add Experience Details"}
//             </button>

//             <AnimatePresence>
//               {showExp && (
//                 <motion.div variants={expVar} initial="hidden" animate="show" exit="exit">
//                   <div className={`${styles.row} ${styles.cols3}`}>
//                     <Field label="Company Name">
//                       <input className={styles.fieldInput} name="companyName" value={formData.companyName} onChange={handleChange} placeholder="Company Ltd." />
//                     </Field>
//                     <Field label="Job Title">
//                       <input className={styles.fieldInput} name="jobTitle" value={formData.jobTitle} onChange={handleChange} placeholder="Senior Manager" />
//                     </Field>
//                     <Field label="Work Location">
//                       <input className={styles.fieldInput} name="experience_location" value={formData.experience_location} onChange={handleChange} placeholder="City, Country" />
//                     </Field>
//                   </div>
//                   <div className={styles.checkRow}>
//                     <input className={styles.checkBox} type="checkbox" id="cwCheck" name="currentlyWorking" checked={formData.currentlyWorking} onChange={handleChange} />
//                     <label className={styles.checkLabel} htmlFor="cwCheck">I am currently working here</label>
//                   </div>
//                   <div className={`${styles.row} ${styles.cols2}`}>
//                     <Field label="Date of Joining">
//                       <input className={styles.fieldInput} type="date" name="dateOfJoining" value={formData.dateOfJoining} onChange={handleChange} />
//                     </Field>
//                     {!formData.currentlyWorking && (
//                       <Field label="Date of Relieving">
//                         <input className={styles.fieldInput} type="date" name="dateOfRelieving" value={formData.dateOfRelieving} onChange={handleChange} />
//                       </Field>
//                     )}
//                   </div>
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </SBlock>

//           {/* 4. Salary */}
//           <SBlock icon={iconMoney} title="Salary Information" delay={0.12}>
//             <div className={`${styles.row} ${styles.cols2}`}>
//               <Field label="Current Salary">
//                 <div className={styles.inputGroup}>
//                   <input className={styles.fieldInput} name="current_salary" value={formData.current_salary} onChange={handleChange} placeholder="e.g. 600000" />
//                   <select className={styles.fieldSelect} name="current_salary_currency" value={formData.current_salary_currency} onChange={handleChange}>
//                     <option value="INR">INR</option>
//                     <option value="USD">USD</option>
//                     <option value="EUR">EUR</option>
//                   </select>
//                 </div>
//               </Field>
//               <Field label="Expected Salary">
//                 <input className={styles.fieldInput} name="expected_salary" value={formData.expected_salary} onChange={handleChange} placeholder="e.g. 800000" />
//               </Field>
//             </div>
//           </SBlock>

//           {/* 5. Availability & Location */}
//           <SBlock icon={iconPin} title="Availability & Location" delay={0.15}>
//             <div className={`${styles.row} ${styles.cols2}`}>
//               <Field label="Available to Join (Days)">
//                 <input className={styles.fieldInput} type="number" name="available_to_join_days" value={formData.available_to_join_days} onChange={handleChange} placeholder="e.g. 30" min="0" />
//               </Field>
//               <Field label="Current Location">
//                 <input className={styles.fieldInput} name="current_location" value={formData.current_location} onChange={handleChange} placeholder="City, State" />
//               </Field>
//             </div>
//           </SBlock>

//           {/* Alerts */}
//           <AnimatePresence>
//             {error && (
//               <motion.div className={styles.alertErr} initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
//                 {error}
//               </motion.div>
//             )}
//             {successMsg && (
//               <motion.div className={styles.alertOk} initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
//                 {successMsg}
//               </motion.div>
//             )}
//           </AnimatePresence>

//           {/* Submit */}
//           <div className={styles.submitRow}>
//             <motion.button
//               type="submit"
//               className={styles.submitBtn}
//               disabled={submitting}
//               whileTap={{ scale: 0.97 }}
//             >
//               {submitting ? (
//                 <>
//                   <svg viewBox="0 0 24 24" style={{ animation: "spin 1s linear infinite" }}><circle cx="12" cy="12" r="10" strokeDasharray="31.4" strokeDashoffset="10"/></svg>
//                   Submitting…
//                 </>
//               ) : (
//                 <>
//                   <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
//                   Submit Application
//                 </>
//               )}
//             </motion.button>
//           </div>

//         </form>
//       </div>

//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//     <Gfooter/>
//     </>
//   );
// }
// export default JobForm;



// both api integration
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./JobForm.module.css";
import Gfooter from "../Component/Gfooter";

gsap.registerPlugin(ScrollTrigger);

// ── APIs ──────────────────────────────────────────────────────────────────────
const ADD_API_1 =
  "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/add_application";

const ADD_API_2 =
  "https://nlfs.in/erp/index.php/Nlf_Erp/add_application";
// ─────────────────────────────────────────────────────────────────────────────

const initial = {
  first_name: "", middle_name: "", last_name: "",
  gender: "", email: "", country_code: "+91", mobile_phone: "",
  experience_years: "", experience_months: "",
  current_salary: "", current_salary_currency: "INR",
  expected_salary: "", available_to_join_days: "",
  current_location: "", current_company: "", linkedin_url: "",
  job_role: "", resume_file: null,
  companyName: "", jobTitle: "", currentlyWorking: false,
  dateOfJoining: "", dateOfRelieving: "", experience_location: "",
};

/* ── Framer variants ── */
const blockVar = {
  hidden: { opacity: 0, y: 36 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] } },
};

const expVar = {
  hidden: { opacity: 0, height: 0, overflow: "hidden" },
  show:   { opacity: 1, height: "auto", transition: { duration: 0.45, ease: "easeOut" } },
  exit:   { opacity: 0, height: 0,    transition: { duration: 0.3 } },
};

/* ── Helper: Section Block ── */
function SBlock({ icon, title, children, delay = 0 }) {
  return (
    <motion.div
      className={styles.sectionBlock}
      variants={blockVar}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      transition={{ delay }}
    >
      <div className={styles.sectionHead}>
        <div className={styles.sectionHeadIcon}>{icon}</div>
        <span className={styles.sectionHeadTitle}>{title}</span>
      </div>
      <div className={styles.sectionBody}>{children}</div>
    </motion.div>
  );
}

/* ── Helper: Field ── */
function Field({ label, required, children }) {
  return (
    <div className={styles.field}>
      <label className={styles.fieldLabel}>
        {label}{required && <span>*</span>}
      </label>
      {children}
    </div>
  );
}

/* ── Helper: build payload for API 1 (cyberathon) ── */
function buildPayload1(formData) {
  const payload = new FormData();

  const keyMap = {
    companyName:     "current_company",
    jobTitle:        "job_title",
    dateOfJoining:   "date_of_joining",
    dateOfRelieving: "date_of_relieving",
  };

  Object.entries(formData).forEach(([key, val]) => {
    if (val === null || val === "") return;
    if (key === "currentlyWorking") {
      payload.append("currently_working", val ? 1 : 0);
      return;
    }
    // skip currency — API1 doesn't need it separately
    if (key === "current_salary_currency") return;
    payload.append(keyMap[key] || key, val);
  });

  return payload;
}

/* ── Helper: build payload for API 2 (nlfs ERP) ──
   Field names exactly as Postman test confirmed working */
function buildPayload2(formData) {
  const payload = new FormData();

  // Exact fields API 2 expects (matches Postman success test)
  const append = (key, val) => {
    if (val !== null && val !== undefined && val !== "") {
      payload.append(key, val);
    }
  };

  append("first_name",            formData.first_name);
  append("middle_name",           formData.middle_name);
  append("last_name",             formData.last_name);
  append("gender",                formData.gender);
  append("email",                 formData.email);
  append("mobile_phone",          formData.mobile_phone);
  append("experience_years",      formData.experience_years);
  append("experience_months",     formData.experience_months);
  append("current_salary",        formData.current_salary);
  append("expected_salary",       formData.expected_salary);
  append("available_to_join_days",formData.available_to_join_days);
  append("current_location",      formData.current_location);
  append("current_company",       formData.companyName);   // company_name field
  append("company_name",          formData.companyName);   // both just in case
  append("linkedin_url",          formData.linkedin_url);
  append("job_role",              formData.job_role);
  append("job_title",             formData.jobTitle);
  append("currently_working",     formData.currentlyWorking ? "Yes" : "No");
  append("date_of_joining",       formData.dateOfJoining);
  append("date_of_relieving",     formData.dateOfRelieving);
  append("experience_location",   formData.experience_location);

  // Resume file if uploaded
  if (formData.resume_file) {
    payload.append("resume_file", formData.resume_file);
  }

  return payload;
}

function JobForm() {
  const location = useLocation();
  const [formData, setFormData]     = useState(initial);
  const [resumeName, setResumeName] = useState("");
  const [error, setError]           = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showExp, setShowExp]       = useState(false);
  const resumeInputRef              = useRef(null);

  const jobRoleFromPage = location.state?.jobRole || "";

  useEffect(() => {
    if (jobRoleFromPage) {
      setFormData(prev => ({ ...prev, job_role: jobRoleFromPage }));
    }
  }, [jobRoleFromPage]);

  /* GSAP entrance on hero */
  const heroRef = useRef(null);
  useEffect(() => {
    if (heroRef.current) {
      gsap.fromTo(
        heroRef.current.querySelectorAll(".gsap-hero-el"),
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, stagger: 0.14, duration: 0.8, ease: "power3.out", delay: 0.1 }
      );
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(p => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setFormData(p => ({ ...p, resume_file: file }));
      setResumeName(file.name);
    }
  };

  const sendEmailNotification = () => {
    const subject = `New Job Application - ${formData.job_role || "Position"}`;
    const body = `
NEW JOB APPLICATION RECEIVED

NAME: ${formData.first_name} ${formData.middle_name} ${formData.last_name}
GENDER: ${formData.gender}
EMAIL: ${formData.email}
PHONE: ${formData.country_code} ${formData.mobile_phone}

JOB ROLE: ${formData.job_role || "Not specified"}
CURRENT LOCATION: ${formData.current_location}

EXPERIENCE: ${formData.experience_years || 0} Years ${formData.experience_months || 0} Months
${formData.companyName         ? `COMPANY: ${formData.companyName}`               : ""}
${formData.jobTitle            ? `POSITION: ${formData.jobTitle}`                 : ""}
${formData.experience_location ? `WORK LOCATION: ${formData.experience_location}` : ""}
${formData.dateOfJoining       ? `JOINING: ${formData.dateOfJoining}`             : ""}
${formData.currentlyWorking    ? "CURRENTLY WORKING: Yes"
  : formData.dateOfRelieving   ? `RELIEVING: ${formData.dateOfRelieving}`         : ""}

CURRENT SALARY: ${formData.current_salary} ${formData.current_salary_currency}
EXPECTED SALARY: ${formData.expected_salary}
AVAILABLE IN: ${formData.available_to_join_days} days

LINKEDIN: ${formData.linkedin_url || "Not provided"}
RESUME: ${resumeName || "Not uploaded"}

Submitted: ${new Date().toLocaleString()}
    `;
    window.location.href = `mailto:info@nlfs.in?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  /* ── SUBMIT ─────────────────────────────────────────────────────────────── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMsg("");

    if (!formData.first_name || !formData.last_name || !formData.email) {
      setError("Please fill all required fields.");
      return;
    }

    try {
      setSubmitting(true);

      /* ── Payload for API 1 (original — currently_working as 0/1) ── */
      const payload1 = buildPayload1(formData);

      /* ── Payload for API 2 (nlfs ERP — exactly as Postman confirmed) ── */
      const payload2 = buildPayload2(formData);

      /* ── Fire both APIs in parallel ── */
      const [result1, result2] = await Promise.allSettled([
        axios.post(ADD_API_1, payload1, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
        axios.post(ADD_API_2, payload2, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
      ]);

      /* ── Log individual results (helpful for debugging) ── */
      console.log("API 1 (cyberathon):", result1);
      console.log("API 2 (nlfs ERP):",  result2);

      /* ── Determine success ──
         Consider submission successful if AT LEAST ONE api returns status true.
         Change to `&&` if you need BOTH to succeed. ── */
      const api1Ok =
        result1.status === "fulfilled" && result1.value?.data?.status;
      const api2Ok =
        result2.status === "fulfilled" &&
        (result2.value?.data?.status === "true" ||
          result2.value?.data?.status === true);

      if (api1Ok || api2Ok) {
        sendEmailNotification();
        const msg =
          result1.value?.data?.message ||
          result2.value?.data?.message ||
          "Application submitted successfully!";
        setSuccessMsg(msg);
        setFormData(initial);
        setResumeName("");
        setShowExp(false);
      } else {
        /* Collect any error messages from both */
        const errMsg =
          result1.reason?.response?.data?.message ||
          result2.reason?.response?.data?.message ||
          result1.value?.data?.message ||
          result2.value?.data?.message ||
          "Submission failed. Please try again.";
        setError(errMsg);
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Network error");
    } finally {
      setSubmitting(false);
    }
  };
  /* ─────────────────────────────────────────────────────────────────────── */

  /* SVG icons */
  const iconPerson = <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>;
  const iconBag    = <svg viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>;
  const iconMoney  = <svg viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>;
  const iconPin    = <svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
  const iconExp    = <svg viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>;

  return (
    <>
      <div className={styles.page}>

        {/* ── TOP BAR ── */}
        <div className={styles.topBar}>
          <Link to="/careers" className={styles.backLink}>
            <svg viewBox="0 0 24 24"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
            Back to all job openings
          </Link>
        </div>

        {/* ── HERO BANNER ── */}
        <div className={styles.heroBanner} ref={heroRef}>
          <div className={styles.heroContent}>
            <div className={`${styles.heroEyebrow} gsap-hero-el`}>Careers at NLF</div>
            <h1 className={`${styles.heroTitle} gsap-hero-el`}>
              Apply for This Position{" "}
              {jobRoleFromPage && (
                <span style={{ color: "#ff0000" }}>- {jobRoleFromPage}</span>
              )}
            </h1>
            <p className={`${styles.heroSub} gsap-hero-el`}>
              Fill in your details below — we'll get back to you shortly.
            </p>
          </div>
        </div>

        {/* ── RESUME UPLOAD ── */}
        <div className={styles.resumeZone}>
          <motion.div
            className={styles.resumeCard}
            onClick={() => resumeInputRef.current?.click()}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.3 }}
            whileHover={{ scale: 1.01 }}
          >
            <div className={styles.resumeIcon}>
              <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
            </div>
            <div className={styles.resumeText}>
              <strong>Upload Resume / CV</strong>
              <small>PDF, DOC, DOCX — max 10 MB</small>
              {resumeName && (
                <div className={styles.resumeFileName}>
                  <svg width="12" height="12" viewBox="0 0 24 24" stroke="#DB0606" fill="none" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                  {resumeName}
                </div>
              )}
            </div>
            <input
              ref={resumeInputRef}
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </motion.div>
        </div>

        {/* ── FORM ── */}
        <div className={styles.formWrap}>
          <form onSubmit={handleSubmit} noValidate>

            {/* 1. Personal Info */}
            <SBlock icon={iconPerson} title="Personal Information" delay={0}>
              <div className={`${styles.row} ${styles.cols3}`}>
                <Field label="First Name" required>
                  <input className={styles.fieldInput} name="first_name" value={formData.first_name} onChange={handleChange} placeholder="John" required />
                </Field>
                <Field label="Middle Name">
                  <input className={styles.fieldInput} name="middle_name" value={formData.middle_name} onChange={handleChange} placeholder="(optional)" />
                </Field>
                <Field label="Last Name" required>
                  <input className={styles.fieldInput} name="last_name" value={formData.last_name} onChange={handleChange} placeholder="Doe" required />
                </Field>
              </div>
              <div className={`${styles.row} ${styles.cols3}`}>
                <Field label="Gender" required>
                  <select className={styles.fieldSelect} name="gender" value={formData.gender} onChange={handleChange} required>
                    <option value="">Select</option>
                    <option>Male</option><option>Female</option><option>Other</option>
                  </select>
                </Field>
                <Field label="Email Address" required>
                  <input className={styles.fieldInput} type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" required />
                </Field>
                <Field label="Mobile Phone">
                  <div className={styles.inputGroup}>
                    <select className={styles.fieldSelect} name="country_code" value={formData.country_code} onChange={handleChange}>
                      <option value="+91">+91</option>
                      <option value="+1">+1</option>
                      <option value="+44">+44</option>
                    </select>
                    <input className={styles.fieldInput} type="tel" name="mobile_phone" value={formData.mobile_phone} onChange={handleChange} placeholder="9876543210" required />
                  </div>
                </Field>
              </div>
            </SBlock>

            {/* 2. Experience */}
            <SBlock icon={iconExp} title="Experience" delay={0.1}>
              <div className={`${styles.row} ${styles.cols4}`}>
                <Field label="Years">
                  <input className={styles.fieldInput} type="number" name="experience_years" value={formData.experience_years} onChange={handleChange} placeholder="0" min="0" />
                </Field>
                <Field label="Months">
                  <select className={styles.fieldSelect} name="experience_months" value={formData.experience_months} onChange={handleChange}>
                    <option value="">Months</option>
                    {Array.from({ length: 12 }, (_, i) => <option key={i} value={i}>{i}</option>)}
                  </select>
                </Field>
              </div>

              {/* Toggle Experience Details */}
              <button
                type="button"
                className={`${styles.expToggleBtn} ${showExp ? styles.open : ""}`}
                onClick={() => setShowExp(v => !v)}
              >
                <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                {showExp ? "Hide Experience Details" : "Add Experience Details"}
              </button>

              <AnimatePresence>
                {showExp && (
                  <motion.div variants={expVar} initial="hidden" animate="show" exit="exit">
                    <div className={`${styles.row} ${styles.cols3}`}>
                      <Field label="Company Name">
                        <input className={styles.fieldInput} name="companyName" value={formData.companyName} onChange={handleChange} placeholder="Company Ltd." />
                      </Field>
                      <Field label="Job Title">
                        <input className={styles.fieldInput} name="jobTitle" value={formData.jobTitle} onChange={handleChange} placeholder="Senior Manager" />
                      </Field>
                      <Field label="Work Location">
                        <input className={styles.fieldInput} name="experience_location" value={formData.experience_location} onChange={handleChange} placeholder="City, Country" />
                      </Field>
                    </div>
                    <div className={styles.checkRow}>
                      <input className={styles.checkBox} type="checkbox" id="cwCheck" name="currentlyWorking" checked={formData.currentlyWorking} onChange={handleChange} />
                      <label className={styles.checkLabel} htmlFor="cwCheck">I am currently working here</label>
                    </div>
                    <div className={`${styles.row} ${styles.cols2}`}>
                      <Field label="Date of Joining">
                        <input className={styles.fieldInput} type="date" name="dateOfJoining" value={formData.dateOfJoining} onChange={handleChange} />
                      </Field>
                      {!formData.currentlyWorking && (
                        <Field label="Date of Relieving">
                          <input className={styles.fieldInput} type="date" name="dateOfRelieving" value={formData.dateOfRelieving} onChange={handleChange} />
                        </Field>
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </SBlock>

            {/* 3. Salary */}
            <SBlock icon={iconMoney} title="Salary Information" delay={0.12}>
              <div className={`${styles.row} ${styles.cols2}`}>
                <Field label="Current Salary">
                  <div className={styles.inputGroup}>
                    <input className={styles.fieldInput} name="current_salary" value={formData.current_salary} onChange={handleChange} placeholder="e.g. 600000" />
                    <select className={styles.fieldSelect} name="current_salary_currency" value={formData.current_salary_currency} onChange={handleChange}>
                      <option value="INR">INR</option>
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                    </select>
                  </div>
                </Field>
                <Field label="Expected Salary">
                  <input className={styles.fieldInput} name="expected_salary" value={formData.expected_salary} onChange={handleChange} placeholder="e.g. 800000" />
                </Field>
              </div>
            </SBlock>

            {/* 4. Availability & Location */}
            <SBlock icon={iconPin} title="Availability & Location" delay={0.15}>
              <div className={`${styles.row} ${styles.cols2}`}>
                <Field label="Available to Join (Days)">
                  <input className={styles.fieldInput} type="number" name="available_to_join_days" value={formData.available_to_join_days} onChange={handleChange} placeholder="e.g. 30" min="0" />
                </Field>
                <Field label="Current Location">
                  <input className={styles.fieldInput} name="current_location" value={formData.current_location} onChange={handleChange} placeholder="City, State" />
                </Field>
              </div>
            </SBlock>

            {/* Alerts */}
            <AnimatePresence>
              {error && (
                <motion.div className={styles.alertErr} initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
                  {error}
                </motion.div>
              )}
              {successMsg && (
                <motion.div className={styles.alertOk} initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
                  {successMsg}
                </motion.div>
              )}
            </AnimatePresence>

            {/* Submit */}
            <div className={styles.submitRow}>
              <motion.button
                type="submit"
                className={styles.submitBtn}
                disabled={submitting}
                whileTap={{ scale: 0.97 }}
              >
                {submitting ? (
                  <>
                    <svg viewBox="0 0 24 24" style={{ animation: "spin 1s linear infinite" }}><circle cx="12" cy="12" r="10" strokeDasharray="31.4" strokeDashoffset="10"/></svg>
                    Submitting…
                  </>
                ) : (
                  <>
                    <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                    Submit Application
                  </>
                )}
              </motion.button>
            </div>

          </form>
        </div>

        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
      <Gfooter />
    </>
  );
}

export default JobForm;